import { SET } from "@/stores/CommumActionTypes";

const mutations = {
	[SET]: (state, setting) =>
	{
		state.trendChartModel = setting;
	},
};

export default { mutations };
